import { Image } from 'react-native'

const images = {
  add_member: Image.resolveAssetSource(
    require('../Images/Light/add_member_icon.png')
  ),
  delete: Image.resolveAssetSource(require('../Images/Light/delete.png')),
  download: Image.resolveAssetSource(require('../Images/Light/download.png')),
  group: Image.resolveAssetSource(require('../Images/Light/group_icon.png')),
  members: Image.resolveAssetSource(
    require('../Images/Light/group_members_icon.png')
  ),
  leave: Image.resolveAssetSource(require('../Images/Light/leave_group.png')),
  leave_icon: Image.resolveAssetSource(require('../Images/Light/logout.png')),
  id_icon: Image.resolveAssetSource(require('../Images/Light/id_icon.png')),
  offer: Image.resolveAssetSource(require('../Images/Light/offer_icon.png')),
  pending: Image.resolveAssetSource(require('../Images/Light/pending.png')),
  upload: Image.resolveAssetSource(require('../Images/Light/upload.png')),
  more: Image.resolveAssetSource(require('../Images/Light/more.png')),
  flash: Image.resolveAssetSource(require('../Images/Light/flash.png')),
  flash_filled: Image.resolveAssetSource(
    require('../Images/Light/flash_filled.png')
  ),
  member_placeholder: Image.resolveAssetSource(
    require('../Images/Light/members_placeholder.png')
  ),
  error: Image.resolveAssetSource(require('../Images/Light/error.png')),
  edit: Image.resolveAssetSource(require('../Images/Light/edit.png')),

  two_slots: Image.resolveAssetSource(require('../Images/Light/two_slots.png')),
  three_slots: Image.resolveAssetSource(
    require('../Images/Light/three_slots.png')
  ),
  four_slots: Image.resolveAssetSource(
    require('../Images/Light/four_slots.png')
  ),
  save: Image.resolveAssetSource(require('../Images/Light/save_icon.png')),
  card_details: Image.resolveAssetSource(
    require('../Images/Light/card_details.png')
  ),
  chevron_white: Image.resolveAssetSource(
    require('../Images/Light/chevron_white.png')
  ),
  location: Image.resolveAssetSource(require('../Images/Light/location.png')),
  marker: Image.resolveAssetSource(require('../Images/Light/marker.png')),
  custom_bundle: Image.resolveAssetSource(
    require('../Images/Light/custom_bundle.png')
  ),
  plan: Image.resolveAssetSource(require('../Images/Light/plan.png')),
  tv: Image.resolveAssetSource(require('../Images/Light/tv.png')),
  green_tick: Image.resolveAssetSource(
    require('../Images/Light/green_tick.png')
  ),
  plan_internet: Image.resolveAssetSource(
    require('../Images/Light/plan_internet.png')
  ),
  plan_messages: Image.resolveAssetSource(
    require('../Images/Light/plan_messages.png')
  ),
  plan_minutes: Image.resolveAssetSource(
    require('../Images/Light/plan_minutes.png')
  ),
  plan_contract: Image.resolveAssetSource(
    require('../Images/Light/plan_contract.png')
  ),
  mobile: Image.resolveAssetSource(require('../Images/Light/mobile.png')),
  red_tick: Image.resolveAssetSource(require('../Images/Light/red_tick.png')),

  // Dark theme

  two_slots_white: Image.resolveAssetSource(require('../Images/Dark/two_slots_white.png')),
  three_slots_white: Image.resolveAssetSource(require('../Images/Dark/three_slots_white.png')),
  four_slots_white: Image.resolveAssetSource(require('../Images/Dark/four_slots_white.png')),
  members_white: Image.resolveAssetSource(require('../Images/Dark/group_members_icon_white.png')),
  offer_white: Image.resolveAssetSource(require('../Images/Dark/offer_icon_white.png')),
  plan_internet_white: Image.resolveAssetSource(require('../Images/Dark/plan_internet_white.png')),
  plan_messages_white: Image.resolveAssetSource(require('../Images/Dark/plan_messages_white.png')),
  plan_minutes_white: Image.resolveAssetSource(require('../Images/Dark/plan_minutes_white.png')),
  tv_white: Image.resolveAssetSource(require('../Images/Dark/tv_white.png')),
  plan_white: Image.resolveAssetSource(require('../Images/Dark/plan_white.png')),
  id_icon_white: Image.resolveAssetSource(require('../Images/Dark/id_icon_white.png')),
  download_white: Image.resolveAssetSource(require('../Images/Dark/download_white.png')),
  mobile_white: Image.resolveAssetSource(require('../Images/Dark/mobile_white.png')),

}

export default images
